<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PKgYFh/media/FC-9798891557529.jpg?1732629343530" alt="This image is the cover for the book Danilo and the Chocolate Hills – Book 3"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Danilo and the Chocolate Hills – Book 3
      </h1>
      <p class="bookDescription body article font2">
        <p>If you haven’t read about Danilo and the Chocolate Hills, here’s what you need to know: Danilo is a good boy, but his decision to skip school and join his friend Carlo on a trip to the Chocolate Hills sets off a dramatic saga. The Evil Giant of the Hills turns them both into tarsiers, a small primate species found in the forests of southeast Asia, including Bohol Island.</p><p>After nearly two months, a monkey saves Danilo by moving him to her colony and purifying him through moonlight bathing at the seaside. Restored to human form, Danilo returns to his family on the back of a dolphin named Paco. Determined to save Carlo, Danilo embarks on a series of inspiring adventures filled with unusual situations, challenges, sacrifices, and twists.</p><p>With the help of Paco the dolphin and the monkey, Danilo finally rescues Carlo from the Evil Giant of the Chocolate Hills. This third and final book in the series takes readers through unexpected situations, thrilling adventures, and uncommon incidents as young Danilo and his determined friend Carlo search for their dolphin friend Paco and confront the Evil Giant in an unprecedented adventure.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Issam Ghazzawi, Firas A. Helli
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0mm;margin-right:37.65pt;margin-bottom:.25pt;margin-left:0mm;font-size:16px;font-family:"Times New Roman",serif;color:black;margin:0mm;text-align:justify;'><span style="font-size:15px;">Issam Ghazzawi is a distinguished professor of management at the University of La Verne. He received his Ph.D. from the University of Pittsburgh, his Master&rsquo;s in Labor and Human Resources (M.L.H.R.) from Ohio State University, and his Master&rsquo;s in Business Administration (MBA) from Sul Ross State University. Additionally, he has more than 20 years of executive management experience and served on several organizations&rsquo; advisory boards.</span></p><p style='margin-top:0mm;margin-right:37.65pt;margin-bottom:.25pt;margin-left:0mm;font-size:16px;font-family:"Times New Roman",serif;color:black;margin:0mm;text-align:justify;'><br></p><p style='margin-top:0mm;margin-right:37.65pt;margin-bottom:.25pt;margin-left:0mm;font-size:16px;font-family:"Times New Roman",serif;color:black;margin:0mm;text-align:justify;'><span style="font-size:15px;">Over the years, he received numerous national and international academic awards. He has also received numerous communities, State of California Assembly, State of California Senate, United States Congress, and the United States Senate awards and recognitions for his service to the community. He serves on the editorial review boards of several academic journals. He started publishing children&rsquo;s stories in a foreign language at the age of 17.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?83a9cc0c